import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createTeamDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('Team').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.MemberPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('Team').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getTeamDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Team').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id, id: doc.id}));
}

export const getTeamDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Team').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getTeamDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('Team').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllTeamDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Team').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateTeamDocument = async (product) => {
    const docRef = db.doc(`/Team/${product._id}`);
    return docRef.update(product);
}

export const checkIsMemberExistsOrNot = async (email) => {
    const snapshot = await db.collection('Team').where("MemberEmail", "==", email).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}